const INITIAL_STATE = {
  data: [],
  isFetching: false,
  addSuccess: false,
  addError: false,
  editSuccess: false,
  editError: false,
  removeSuccess: false,
  removeError: false,
  getAllError: false,
  errorContent: ''
};

const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'CODES_NCM_START_REQUEST':
      return {
        ...state,
        isFetching: true,
        addError: false,
        editError: false,
        errorContent: ''
      };
    case 'CODES_NCM_END_REQUEST':
      return {
        ...state,
        addSuccess: false,
        editSuccess: false,
        removeSuccess: false,
        isFetching: false
      };
    case 'CODES_NCM_GET_ALL_SUCCESS':
      return {
        ...state,
        data: payload
      };
    case 'CODES_NCM_GET_ALL_ERROR':
      return {
        ...state,
        getAllError: true,
        errorContent: payload
      };
    case 'CODES_NCM_ADD_SUCCESS':
      return {
        ...state,
        data: state.data.concat([payload]),
        addSuccess: true,
        addError: false
      };
    case 'CODES_NCM_ADD_ERROR':
      return {
        ...state,
        addSuccess: false,
        addError: true,
        errorContent: payload
      };
    case 'CODES_NCM_EDIT_SUCCESS':
      return {
        ...state,
        data: state.data.map(item =>
          item._id !== payload._id ? { ...item } : { ...payload }
        ),
        editSuccess: true,
        editError: false
      };
    case 'CODES_NCM_EDIT_ERROR':
      return {
        ...state,
        editSuccess: false,
        editError: true,
        errorContent: payload
      };
    case 'CODES_NCM_REMOVE_SUCCESS':
      return {
        ...state,
        removeSuccess: true,
        removeError: false,
        data: state.data.map(item =>
          item._id !== payload ? { ...item } : { ...item, active: false }
        )
      };
    case 'CODES_NCM_REMOVE_ERROR':
      return {
        ...state,
        removeSuccess: false,
        removeError: true,
        errorContent: payload
      };
    case 'CODES_NCM_MODIFY_STORE': {
      const ids = payload.map(item => item._id);
      const items = state.data.filter(item => !ids.includes(item._id));
      return {
        ...state,
        data: items.concat(payload)
      };
    }
    default:
      return { ...state };
  }
};

export default reducer;
